import React from 'react';
import PropTypes from 'prop-types';

const FormatNumber = ({ number }) => {
  if (Math.round(number) === 0) {
    return '';
  }
  if (number > 0) {
    return (
      <span className="positive">
        {`(+ ${Math.abs(Math.round(number)).toLocaleString('en-IN')})`}
      </span>
    );
  }
  return (
    <span className="negative">
      {`(- ${Math.abs(Math.round(number)).toLocaleString('en-IN')})`}
    </span>
  );
};

FormatNumber.propTypes = {
  number: PropTypes.number,
};

FormatNumber.defaultProps = {
  number: 0,
};

export default FormatNumber;



// WEBPACK FOOTER //
// ./src/components/FormatNumber/index.js